module.exports = "<div> <ol class=c-tab-content__publication-list> <li class=c-tab-content__publication v-for=\"publication in value.list\"> {{publication}} </li> </ol> <a :href=value.orion class=c-tab-content__orion-link target=_blank> {{ trans( \"Additional bibliography:\" ) }} {{ trans( \"The Orion Center\" ) }} <span class=\"i-icon i-ext-link\" role=presentation></span> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/archive/templates/publications.html
// module id = 161
// module chunks = 0